import { DTOModel } from "src/models/base/dto-model";
import { BaseApiService } from "../base";
import { TravelExpenseSTO } from "../../models/travel-expenses/travel-expense-sto";
import { SaveResponse } from "src/models/api/save";

export class TravelExpensesApiService extends BaseApiService<DTOModel, TravelExpenseSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeExpenseReports",
      loadItemsPath: "",
      saveItemsPath: "",
    });
  }

  public saveTravelExpenseAuditDetails = (items: TravelExpenseSTO[]): Promise<SaveResponse> => {
    this.useSaveItemsPath("/SaveTravelExpenseAuditDetails");
    const response = this.saveItems([...items]);

    return response;
  };

  public saveTravelExpenseAuditStatus = (items: TravelExpenseSTO[]): Promise<SaveResponse> => {
    this.useSaveItemsPath("/SaveTravelExpenseAuditStatus");
    const response = this.saveItems([...items]);

    return response;
  };

  public saveTravelExpenseAuditDocument = (items: TravelExpenseSTO[]): Promise<SaveResponse> => {
    this.useSaveItemsPath("/SaveTravelExpenseAuditDocument");
    const response = this.saveItems([...items]);

    return response;
  };
}
